module.exports = __webpack_public_path__ + "static/media/StoreFront.7f1fbe3f.jpg";